app.service('partnerSubscriptionManager', function (message, broker, modal, loading, html, basketAnalytics) {

	let productId;
	let productPlu;
	let group;
	let savedServices = [];
	let relatedPromotionIdentifier;
	let $checkboxes, $checkboxAndSelects, $confirm;

	function load(params) {
		productId = params.product;
		productPlu = params.productPlu;
		group = params.group;
		relatedPromotionIdentifier = params.relatedPromotionIdentifier;
		savedServices = params.added;
		loading.start();
		$.ajax({
			url: '/cart-partner-subscriptions.ltr',
			data: {
				productId,
				partnerSubscriptionGroupId: group,
				relatedPromotionIdentifier
			},
			success: function (response) {
				loading.stop();
				modal.generate({
					content: response,
					modifier: html.has('new-services') ? ' remodal-right' : ' remodal-full-width',
					id: 'modal-partner-subscriptions',
					callbackOpen: function () {
						$checkboxes = $('#modal-partner-subscriptions input:checkbox');
						$checkboxAndSelects = $('#modal-partner-subscriptions').find('.js-partner-service-quantity, input:checkbox');
						$confirm = $('#modal-partner-subscriptions .js-partner-subscription-save');
						$('#modal-partner-subscriptions .js-partner-subscription-change-more').on('click', function (event) {
							$(this).closest('.partner-subscription-item').toggleClass('extended');
							event.stopPropagation();
							event.preventDefault();
						}).on('keyup keypress keydown', function (event) {
							event.stopPropagation();
						})
						$checkboxAndSelects.change(() => {
							$confirm.removeAttr('disabled');
						});
						$confirm.click(function () {
							save();
							modal.close();
						});
					}
				})
			},
			error: function () {
				modal.alert('Błąd pobierania danych');
			}
		});
	}

	function save() {
		const toAddList = [];
		const toRemoveList = [];
		const toUpdateList = [];
		const focusParams = {
			productId: productId,
			group: group
		};
		function checkPrevQuantity(value) {
			const prevQuantity = savedServices.filter(service => service.id == value);
			return prevQuantity.length ? prevQuantity[0].quantity : 0;
		}

		function removeSelected() {
			focusParams.type = 'basket-partner-subscription-modal-remove';
			const item = toRemoveList.shift();
			basketAnalytics.removePartnerSubscription(productId, item);
			update('remove', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item
			}, function () {
				run();
			},)
		}
		function addSelected() {
			focusParams.type = 'basket-partner-subscription-modal-add';
			const item = toAddList.shift();
			basketAnalytics.addPartnerSubscription(productId, item.serviceId, item.quantity);
			update('add', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item.serviceId,
				quantity: item.quantity
			}, function () {
				run();
			});
		}

		function updateSelected() {
			focusParams.type = 'basket-partner-subscription-modal-update';
			const item = toUpdateList.shift();
			update('change', {
				productId,
				relatedPromotionIdentifier,
				partnerSubscriptionId: item.serviceId,
				quantity: item.quantity
			}, function () {
				run();
			});
		}

		function endSelected() {
			modal.close();
			broker.trigger('REFRESH_BASKET_VIEW', focusParams);
		}

		function run() {
			if (toRemoveList.length) {
				removeSelected();
			} else if (toUpdateList.length) {
				updateSelected();
			} else if (toAddList.length) {
				addSelected();
			} else {
				endSelected();
			}
		}

		function update(action, options) {
			let url = '';
			if (action == 'remove') {
				url = '/remove-partner-subscription.ltr';
			} else if (action == 'change') {
				url = '/cart-update-partner-subscription-quantity.ltr';
			} else if (action == 'add') {
				url = '/add-partner-subscriptions-to-cart.ltr';
			}
			$.ajax({
				url: url,
				type: 'POST',
				data: options,
				cache: false,
				success: function (json) {
					if (json.status == 'SUCCESS') {
						run();
					} else if (json.status == 'FAIL') {
						let failMessage = json.messages;
						if (failMessage && typeof (failMessage) === 'object') {
							failMessage = failMessage[0];
						}
						if (failMessage.startsWith('msg:')) {
							message.alert(failMessage, function () {
								broker.trigger('REFRESH_BASKET_VIEW', focusParams);
							});
						} else {
							modal.alert(failMessage, function () {
								broker.trigger('REFRESH_BASKET_VIEW', focusParams);
							});
						}
					} else {
						modal.alert('Nieznany błąd przy usługach partnerskich', function () {
							broker.trigger('REFRESH_BASKET_VIEW', focusParams);
						});
					}
				},
				error: function () {
					loading.stop();
					modal.alert('Błąd dodawania usługi. Prosimy spróbować później', function () {
						broker.trigger('REFRESH_BASKET_VIEW', focusParams);
					})
				}
			});
		}


		$checkboxes.each(function () {
			const $this = $(this);
			const checked = $this.is(':checked');
			const value = $this.val();
			const currentQuantity = $this.parent().find('.js-partner-service-quantity').val();
			const prevQuantity = checkPrevQuantity(value);
			if (checked && prevQuantity === 0) {
				toAddList.push({ serviceId: value, quantity: currentQuantity })
			} else if (!checked && prevQuantity > 0) {
				toRemoveList.push(value);
			} else if (checked && prevQuantity > 0 && prevQuantity != currentQuantity) {
				toUpdateList.push({ serviceId: value, quantity: currentQuantity })
			}
		});

		loading.start();
		run();
	}

	return {
		load
	};
});
